<div class="b2a-button b2a-button--{{ type }} b2a-button-disabled--{{ disabledStyle }} b2a-button-size--{{ size }}">
  <button [disabled]="disabled" type="button" color="primary" mat-raised-button (click)="buttonClicked()">
    {{ label }}
  </button>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/button/button.component.html